export const PersonalAuto = "PERSONALAUTO";
export const CommercialAuto = "COMMERCIALAUTO";
export const CommercialTrucking = "COMMERCIALTRUCKING";
export const RecreationalVehicle = "RECREATIONAL";
